module.exports = __webpack_public_path__ + "img/signature-with-pen.b4287ea0.svg";